function reportTemplatePayload(item) {
  const payload = item?.payload;
  if (!payload || typeof payload !== 'object') {
    return null;
  }
  const template = payload.canvas_report_template || payload.report_template;
  return template && typeof template === 'object' && !Array.isArray(template) ? template : null;
}

function normalizeReportTemplate(rawTemplate) {
  const sectionOrder = Array.isArray(rawTemplate.sectionOrder)
    ? rawTemplate.sectionOrder
    : (Array.isArray(rawTemplate.section_order) ? rawTemplate.section_order : undefined);
  return { ...rawTemplate, ...(sectionOrder ? { sectionOrder } : {}) };
}

export function selectCanvasReportTemplate(timelineItems = []) {
  const items = Array.isArray(timelineItems) ? timelineItems : [];
  const template = items.reduceRight((selected, item) => selected || reportTemplatePayload(item), null);
  return template ? normalizeReportTemplate(template) : null;
}

export default selectCanvasReportTemplate;
